import { MantineThemeOverride } from '@mantine/core';

export type PaperTheme = NonNullable<MantineThemeOverride['components']>['Paper'];

export const Paper: PaperTheme = {
  // todo: define
};
